export type AseExam = {
    code: string;
    title: string;
};

export type AseExamCategory = {
    title: string;
    exams: AseExam[];
};

export const aseExamCategories: AseExamCategory[] = [
    {
        title: "Auto",
        exams: [
            {
                code: "A1",
                title: "Engine Repair",
            },
            {
                code: "A2",
                title: "Automatic Transmission/Transaxle",
            },
            {
                code: "A3",
                title: "Manual Drive Train &amp; Axles",
            },
            {
                code: "A4",
                title: "Suspension &amp; Steering",
            },
            {
                code: "A5",
                title: "Brakes",
            },
            {
                code: "A6",
                title: "Electrical/Electronic Systems",
            },
            {
                code: "A7",
                title: "Heating & Air Conditioning",
            },
            {
                code: "A8",
                title: "Engine Performance",
            },
            {
                code: "A9",
                title: "Light Vehicle Diesel Engines"
            }
        ],
    },
    {
        title: "Truck",
        exams: [
            {
                code: "T1",
                title: "Gasoline Engines"
            },
            {
                code: "T2",
                title: "Diesel Engines"
            },
            {
                code: "T3",
                title: "Drive Train"
            },
            {
                code: "T4",
                title: "Brakes"
            },
            {
                code: "T5",
                title: "Suspension and Steering"
            },
            {
                code: "T6",
                title: "Electrical/Electronic Systems"
            },
            {
                code: "T7",
                title: "Heating, Ventilation & Air Conditioning (HVAC)"
            }
        ]
    }
];

export const aseExamsMap = new Map<string, [string, AseExam]>(
  aseExamCategories.flatMap((cat) =>
    cat.exams.map((exam) => [exam.code, [cat.title, exam]])
  )
);